<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectType" });
import { SelectSingle } from "../../../../selects/index.js";
import { TYPES } from "../../config/types.js";
import { t } from "svelte-i18n";
export let key;
export let isDisabled = false;
export let isRequired = true;
$: options = TYPES.map((option) => ({ ...option, label: $t(option.label) }));
</script>

<SelectSingle
    bind:key
    label = 'resource.address.properties.type.label'
    name = 'address.type'
    placeholder = 'resource.address.properties.type.placeholder'
    { options }
    { isDisabled }
    { isRequired }
/>